const TRANSLATE = {
  title: 'Tokens Públicos',
  newPublicToken: 'Nuevo token público',
  editPublicToken: 'Editar token público',
  name: 'Nombre',
  availableUses: 'Usos disponibles',
  validUntil: 'Válido hasta',
  enabled: 'Activado',
  action: 'Acción',
  maxExecution: 'Máximo de ejecución',
  expiresAt: 'Vence en',
  usageType: 'Tipo de uso',
  conditions: 'Condiciones',
  payload: 'Payload',
  remainingUses: 'Uso restante',
  expireDate: 'Fecha límite',
  publicUrl: 'URL pública',
  calls: '{{count}} llamada',
  calls_plural: '{{count}} llamadas',
  noLimit: 'Sin límite',
  noExpireDate: 'Sin fecha límite',
  createdAt: 'Fecha de creación',
  moreDetails: 'Más detalles',
  lessDetails: 'Menos detalles',
  called: 'Llamado',
  error: 'Error',
  success: 'Éxito',
  confirmRemove: '¿Está seguro de que desea eliminar?'
}

export default TRANSLATE
